module.exports = __webpack_public_path__ + "img/BGMain5.d36ddb77.jpg";